<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-full"
    title="インターネットFWプロファイル設定"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container fluid>
                <!-- 名前 -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="名前"
                      :msg="
                        $filter.message('info_max_length', { maxLength: '20' })
                      "
                      placement="end"
                    />
                    <validation-provider
                      name="profileInternetFwName"
                      v-model="form.profileInternetFwName"
                      label="名前"
                      :rules="{
                        required: true,
                        max: { length: 20 },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- アプリケーション -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="アプリケーション"
                      :is-required="false"
                      :isInfo="false"
                    />
                    <v-radio-group inline v-model="isSelectApp" hide-details>
                      <v-radio label="any" :value="false" />
                      <v-radio label="Select" :value="true" />
                    </v-radio-group>
                  </v-col>
                </v-row>

                <template v-if="isSelectApp">
                  <v-row>
                    <!-- アプリケーションカテゴリ -->
                    <v-col>
                      <app-badge
                        item="カテゴリ"
                        :is-required="false"
                        :isInfo="false"
                      />
                      <app-select-search
                        :items="appCategories"
                        multiple
                        chips
                        closable-chips
                        v-model="appCategoriesSelected"
                        @update:modelValue="filterApplication"
                      />
                    </v-col>
                    <!-- アプリケーションサブカテゴリ -->
                    <v-col>
                      <app-badge
                        item="サブカテゴリ"
                        :is-required="false"
                        :isInfo="false"
                      />
                      <app-select-search
                        :items="appSubcategories"
                        multiple
                        chips
                        closable-chips
                        v-model="appSubcategoriesSelected"
                        @update:modelValue="filterApplication"
                      />
                    </v-col>
                    <!-- アプリケーションテクノロジー -->
                    <v-col>
                      <app-badge
                        item="テクノロジー"
                        :is-required="false"
                        :isInfo="false"
                      />
                      <app-select-search
                        :items="appTechnologies"
                        multiple
                        chips
                        closable-chips
                        v-model="appTechnologiesSelected"
                        @update:modelValue="filterApplication"
                      />
                    </v-col>
                    <!-- アプリケーションリスク -->
                    <v-col>
                      <app-badge
                        item="リスク"
                        :is-required="false"
                        :isInfo="false"
                      />
                      <app-select-search
                        :items="appRisks"
                        multiple
                        chips
                        closable-chips
                        v-model="appRisksSelected"
                        @update:modelValue="filterApplication"
                      />
                    </v-col>
                  </v-row>
                  <!-- 選択アプリケーション -->
                  <v-row>
                    <v-col>
                      <app-badge item="選択アプリケーション" :isInfo="false" />
                      <validation-provider
                        name="applicationList"
                        v-model="form.applicationList"
                        label="選択アプリケーション"
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage }"
                        class="select-mb"
                      >
                        <app-multi-select
                          :options="filterApplications"
                          :multiple="true"
                          label="applicationName"
                          openDirection="auto"
                          trackBy="applicationSeq"
                          :sort-orders="[['applicationName', 'asc']]"
                          v-bind="componentField"
                          :error-messages="errorMessage"
                          class="adjust-height"
                        >
                          <template #beforeList>
                            <v-row class="multiselect-thead" no-gutters>
                              <p class="v-col-4">アプリケーション</p>
                              <p class="v-col-2">カテゴリ</p>
                              <p class="v-col-2">サブカテゴリ</p>
                              <p class="v-col-2">テクノロジー</p>
                              <p class="v-col-2">リスク</p>
                            </v-row>
                          </template>

                          <template #tag="{ option, remove }">
                            <multi-select-tag
                              class="d-block"
                              :option="option"
                              :remove="remove"
                            >
                              <div class="multiselect-tbody">
                                <p class="v-col-4">
                                  {{ option.applicationName }}
                                </p>
                                <p class="v-col-2">{{ option.category }}</p>
                                <p class="v-col-2">
                                  {{ $filter.emptyTo(option.subcategory, "-") }}
                                </p>
                                <p class="v-col-2">
                                  {{ $filter.emptyTo(option.technology, "-") }}
                                </p>
                                <p class="v-col-2">{{ option.risk }}</p>
                              </div>
                            </multi-select-tag>
                          </template>

                          <template #option="{ option }">
                            <div class="multiselect-tbody">
                              <p class="v-col-4">
                                {{ option.applicationName }}
                              </p>
                              <p class="v-col-2">{{ option.category }}</p>
                              <p class="v-col-2">
                                {{ $filter.emptyTo(option.subcategory, "-") }}
                              </p>
                              <p class="v-col-2">
                                {{ $filter.emptyTo(option.technology, "-") }}
                              </p>
                              <p class="v-col-2">{{ option.risk }}</p>
                            </div>
                          </template>
                        </app-multi-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </template>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat">{{
                  internetFwProfileInfo ? "変更" : "追加"
                }}</v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >キャンセル</v-btn
                >
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import { VueFinalModal } from "vue-final-modal";
import MultiSelectTag from "@/components/MultiSelectTag.vue";
import type {
  InternetfwApplication,
  InternetfwProfileInfo,
  SetInternetfwProfile,
} from "@/apis/InternetfwProfileApi";

export default defineComponent({
  name: "ProfileInternetFwEdit",
  components: { MultiSelectTag },
  props: {
    internetFwProfileInfo: {
      type: Object as PropType<InternetfwProfileInfo>,
      default: null,
      required: false,
    },
    type4Id: {
      type: String as PropType<string>,
      required: false,
      default: null,
    },
    profileInternetFwSeq: {
      type: String as PropType<string>,
      required: false,
      default: "",
    },
    profileInternetFwKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      isLoaded: false,
      form: {} as InternetfwProfileInfo,
      isSelectApp: false,
      appCategories: [] as string[],
      appCategoriesSelected: [] as string[],
      appSubcategories: [] as string[],
      appSubcategoriesSelected: [] as string[],
      // 全件のサブカテゴリリスト（カテゴリクリアした場合、再計算不要のため）
      allSubcategories: [] as string[],
      appTechnologies: [] as string[],
      appTechnologiesSelected: [] as string[],
      appRisks: [] as number[],
      appRisksSelected: [] as number[],
      applications: [] as InternetfwApplication[],
      filterApplications: [] as InternetfwApplication[],
    };
  },
  async mounted() {
    if (this.internetFwProfileInfo) {
      // 更新の場合は遷移元のデータを設定
      this.form = { ...this.internetFwProfileInfo };
      // アプリケーションが選択か判定しブール値で保持
      this.isSelectApp = !!this.form.applicationList.length;
    }
    await this.load();
    // フィルター用にアプリケーションリストをコピー
    this.filterApplications = this.applications;
    this.isLoaded = true;
  },
  watch: {
    appCategoriesSelected() {
      // サブカテゴリ選択肢の切り替え
      if (this.appCategoriesSelected.length > 0) {
        this.appSubcategories = [
          ...new Set(
            this.applications
              .filter((e) =>
                this.appCategoriesSelected.some((v) => v === e.category)
              )
              .map((e) => e.subcategory || "-")
          ),
        ].sortBy([(e) => e, "asc"]);
      } else {
        this.appSubcategories = this.allSubcategories;
      }
      // 選択肢リストに存在しないサブカテゴリのクリア
      this.appSubcategoriesSelected = this.appSubcategoriesSelected.filter(
        (v) => this.appSubcategories.some((e) => v === e)
      );
    },
  },
  methods: {
    /** 初期表示時の処理 */
    async load() {
      // アプリケーションの取得
      this.applications = (
        await this.$api.internetfwProfileApi.getInternetfwApplications()
      ).sortBy([(e: InternetfwApplication) => e.applicationName, "asc"]);

      // カテゴリから重複する項目を除去して、昇順にソートする
      this.appCategories = [
        ...new Set(this.applications.map((e) => e.category)),
      ].sortBy([(e) => e, "asc"]);

      // サブカテゴリから重複する項目を除去して、昇順にソートする
      this.allSubcategories = [
        ...new Set(this.applications.map((e) => e.subcategory || "-")),
      ].sortBy([(e) => e, "asc"]);
      this.appSubcategories = this.allSubcategories;

      // テクノロジーから重複する項目を除去して、昇順にソートする
      this.appTechnologies = [
        ...new Set(this.applications.map((e) => e.technology || "-")),
      ].sortBy([(e) => e, "asc"]);

      // リスクから重複する項目を除去して、昇順にソートする
      this.appRisks = [...new Set(this.applications.map((e) => e.risk))].sortBy(
        [(e) => e, "asc"]
      );
    },
    /** プロファイル情報の登録・更新処理 */
    async submit() {
      // 確認ダイアログの表示
      const action = this.internetFwProfileInfo ? "変更" : "追加";
      await this.$confirm(`プロファイルを${action}します。よろしいですか？`);

      // 登録・更新データの設定
      const reqData: SetInternetfwProfile = {
        profileInternetFwName: this.form.profileInternetFwName,
        applicationSeqList: this.isSelectApp
          ? this.form.applicationList.map((e) => e.applicationSeq)
          : [],
        description: this.form.description || null,
        profileInternetFwKeyId: this.profileInternetFwKeyId,
        note: null,
      };

      // プロファイル(インターネットFW)の登録・更新
      if (this.internetFwProfileInfo) {
        await this.modifyProfile(reqData);
      } else {
        await this.registerProfile(reqData);
      }
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /**
     * プロファイル(インターネットFW)の登録処理
     * @param reqData 登録データ
     */
    async registerProfile(reqData: SetInternetfwProfile) {
      // Type4IDの有無により呼び出すAPIをハンドリング
      if (!this.type4Id) {
        await this.$api.internetfwProfileApi.postType1Profile(reqData);
      } else {
        await this.$api.internetfwProfileApi.postType4Profile(
          this.type4Id,
          reqData
        );
      }
    },
    /**
     * プロファイル(インターネットFW)の更新処理
     * @param reqData 更新データ
     */
    async modifyProfile(reqData: SetInternetfwProfile) {
      // Type4IDの有無により呼び出すAPIをハンドリング
      if (!this.type4Id) {
        await this.$api.internetfwProfileApi.putType1Profile(
          this.profileInternetFwSeq,
          reqData
        );
      } else {
        await this.$api.internetfwProfileApi.putType4Profile(
          this.type4Id,
          this.profileInternetFwSeq,
          reqData
        );
      }
    },
    /** アプリケーションリストをプルダウンからフィルターする際の処理 */
    filterApplication() {
      this.filterApplications = this.applications
        .filter((app) =>
          this.appCategoriesSelected.length > 0
            ? this.appCategoriesSelected.some((e) => e === app.category)
            : true
        )
        .filter((app) =>
          this.appSubcategoriesSelected.length > 0
            ? this.appSubcategoriesSelected.some((e) => {
                if (e === "-") return null === app.subcategory;
                return e === app.subcategory;
              })
            : true
        )
        .filter((app) =>
          this.appTechnologiesSelected.length > 0
            ? this.appTechnologiesSelected.some((e) => {
                if (e === "-") return null === app.technology;
                return e === app.technology;
              })
            : true
        )
        .filter((app) =>
          this.appRisksSelected.length > 0
            ? this.appRisksSelected.some((e) => e === app.risk)
            : true
        );
    },
  },
});
</script>

<style lang="scss" scoped>
// マルチセレクトの表示領域を拡大するためのスタイル
.select-mb {
  margin-bottom: 4.5rem;
}
:deep(.adjust-height .multiselect__content-wrapper) {
  // WVS2UI-9717 applicationの選択Popupの高さを拡大
  max-height: 260px !important;
}
.modal-body {
  min-height: 70vh !important;
}
</style>
